import moment from "moment";
import { add_acquisition_observables } from "./Acquisition";
import { Artist } from "./Artist";
import { SCEvent } from "./Event";
import { UsedGiftCard } from "./GiftCard";
import { BasePerson as Person } from "./Person";
import { TAXRATE_TYPES } from '../common/constants';
import { Modal } from 'bootstrap';

export class Invoice {
  constructor(data) {
    var self = this;
    self.type = "Invoice";

    self.rootvm = data.rootvm;
    self.invoice_uuid = ko.observable(data.invoice_uuid);
    self.invoice_number = ko.observable(data.invoice_number);
    self.invoice_type = ko.observable(data.invoice_type);
    self.payin_uuid = ko.observable(data.payin_uuid);

    self.gift_mangopay_id = ko.observable(data.gift_mangopay_id);

    self.mangopay_transferid = ko.observable(data.mangopay_transferid);

    self.invoice_date = ko.observable(
      new moment(data.invoice_date).format("DD.MM.YY")
    );

    self.sender_name = ko.observable(data.sender_name);
    self.sender_address = ko.observable(data.sender_address);
    self.sender_uuid = ko.observable(data.sender_uuid);

    self.receiver_name = ko.observable(data.receiver_name);
    self.receiver_address = ko.observable(data.receiver_address);
    self.receiver_uuid = ko.observable(data.receiver_uuid);
    self.extra_line_invoice = ko.observable(data.extra_line_invoice);

    // First touch marketing channel of the receiver (the host on a fee
    // invoice). Comes from person_referrer_event_report, so it is missing
    // for people who signed up before referrer tracking.
    add_acquisition_observables(self, data.acquisition);

    // The source only means anything on a fee invoice, where the receiver is
    // the host. A commission invoice goes to the artist.
    self.show_acquisition = ko.pureComputed(function () {
      return String(self.invoice_type() || "").startsWith("fee");
    });

    self.receiver = ko.observable();
    self.sender = ko.observable();

    if (data.receiver) {
      data.receiver.rootvm = data.rootvm;
      self.receiver(new Person(data.receiver));
    }
    if (data.sender) {
      data.sender.rootvm = data.rootvm;
      self.sender(new Person(data.sender));
    }

    self.brutto = ko.observable(data.brutto);
    self.commission_brutto = ko.observable(data.commission_brutto);
    self.commission = ko.observable(data.commission);

    self.selected_payment_method = ko.observable(data.selected_payment_method);

    self.send_email_reminders = ko.observable(data.send_email_reminders);
    self.new_send_email_reminders = ko.observable(data.send_email_reminders);

    self.calculated_payment_method = ko.pureComputed(function () {
      if (self.selected_payment_method() == "transfer") {
        return "Bank";
      } else {
        return "MP";
      }
    });

    self.used_gift_cards = ko.observableArray(
      ko.utils.arrayMap(data.used_gift_cards || [], function (x) {
        return new UsedGiftCard(x);
      })
    );

    self.first_used_gift_card = ko.pureComputed(function () {
      if (self.used_gift_cards().length > 0) {
        return self.used_gift_cards()[0];
      }
    });

    self.payment_method_split = ko.pureComputed(function () {
      if (self.invoice_type() == "fee" && self.first_used_gift_card()) {
        var pay_amount =
          self.brutto() - self.first_used_gift_card().amount_used();

        return (
          self.selected_payment_method() +
          "(" +
          pay_amount.toFixed(2) +
          ") -" +
          self.first_used_gift_card().pretty_gc_type() +
          "(" +
          self.first_used_gift_card().amount_used() +
          ")"
        );
      }
      if (
        self.invoice_type() == "flatcommission" &&
        self.first_used_gift_card()
      ) {
        var pay_amount =
          self.brutto() - self.first_used_gift_card().amount_used();
        if (pay_amount == 0) {
          return (
            self.first_used_gift_card().pretty_gc_type() +
            "(" +
            self.first_used_gift_card().amount_used() +
            ")"
          );
        }
      }

      if (self.invoice_type() == "proartist" && self.first_used_gift_card()) {
        var pay_amount =
          self.brutto() - self.first_used_gift_card().amount_used();
        return (
          self.selected_payment_method() +
          "(" +
          pay_amount.toFixed(2) +
          ") -" +
          self.first_used_gift_card().pretty_gc_type() +
          "(" +
          self.first_used_gift_card().amount_used() +
          ")"
        );
      }

      if (self.invoice_type() == "fee") {
        return self.selected_payment_method();
      } else {
        return self.selected_payment_method();
      }
    });

    self.extra_notes = ko.observable(data.extra_notes);
    self.new_extra_notes = ko.observable(data.extra_notes);

    self.editing_extra_notes = ko.observable(false);

    self.currency = ko.observable(data.currency);

    self.tax_mode = ko.observable(data.tax_mode);
    self.tax_mode_home_country = ko.observable(data.tax_mode_home_country);
    self.tax_rate = ko.observable(data.tax_rate);

    self.reverse_charge = ko.observable(data.reverse_charge);

    self.commission_tax_mode = ko.observable(data.commission_tax_mode);
    self.commission_tax_mode_home_country = ko.observable(
      data.commission_tax_mode_home_country
    );
    self.commission_tax_rate = ko.observable(data.commission_tax_rate);
    self.commission_reverse_charge = ko.observable(
      data.commission_reverse_charge
    );

    self.pretty_tax_rate = ko.computed(function () {
      if (self.tax_rate() == 0 || self.tax_rate()) {
        return self.tax_rate();
      } else {
        return self.commission_tax_rate();
      }
    });

    self.pretty_reverse_charge = ko.computed(function () {
      if (self.reverse_charge() != undefined) {
        if (self.reverse_charge() == true) {
          return "X";
        }
      } else if (self.commission_reverse_charge() != undefined) {
        if (self.commission_reverse_charge() == true) {
          return "X";
        }
      }
    });

    self.pretty_tax_mode = ko.computed(function () {
      if (!(self.tax_mode() || self.commission_tax_mode())) return "";
      return (
        (self.tax_mode() || self.commission_tax_mode()) +
        "(" +
        (self.tax_mode_home_country() ||
          self.commission_tax_mode_home_country()) +
        ")"
      );
    });

    self.paid_date = ko.observable();
    if (data.paid_date) {
      self.paid_date(new moment(data.paid_date).format("DD.MM.YY"));
    }

    self.cancelled_date = ko.observable();
    if (data.cancelled) {
      self.cancelled_date(new moment(data.cancelled).format("DD.MM.YY"));
    }

    self.refunded_date = ko.observable();
    if (data.refunded) {
      self.refunded_date(new moment(data.refunded).format("DD.MM.YY"));
    }

    self.due_date = ko.observable();
    self.overdue = ko.observable(false);
    if (data.due_date) {
      var m = new Date(data.due_date);
      self.due_date(m);
      const day = String(m.getDate()).padStart(2, '0');
      const month = String(m.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
      const year = String(m.getFullYear());
      self.due_date(`${year}-${month}-${day}`);

      const today = new Date();
      self.overdue(m < today);
    }
    self.delivery_date = ko.observable();
    if (data.delivery_date) {
      self.delivery_date(new moment(data.delivery_date).format("DD.MM.YY"));
    }

    self.event_obj = ko.observable();
    if (data.event) {
      data.event.rootvm = self.rootvm;
      self.event_obj = ko.observable(new SCEvent(data.event));
    }

    self.artist = ko.observable();
    if (data.artist) {
      data.artist.rootvm = self.rootvm;
      self.artist(new Artist(data.artist));
    }

    self.confirmed_event_date = ko.computed(function () {
      if (self.event_obj()) {
        return new moment(self.event_obj().confirmed_event_date()).format(
          "DD.MM.YY"
        );
      }
    });
    self.event_type = ko.computed(function () {
      if (self.event_obj()) {
        return self.event_obj().event_type();
      }
    });

    self.is_commission = ko.computed(function () {
      return (
        self.invoice_type() == "commission" ||
        self.invoice_type() == "commission-partial"
      );
    });

    self.amount = ko.computed(function () {
      if (self.is_commission()) {
        return self.commission_brutto() || self.commission();
      } else {
        return self.brutto();
      }
    });

    self.artist_payment = ko.computed(function () {
      if (self.is_commission()) {
        return self.brutto() - self.commission_brutto();
      } else {
        return 0;
      }
    });

    self.payout = ko.observable();

    if (data.payout) {
      // for now just the first
      var p = data.payout;
      p.rootvm = self.rootvm;
      self.payout(new Payout(p));
    }

    self.payin = ko.observable();
    if (data.payin) {
      var p = data.payin;
      p.rootvm = self.rootvm;
      self.payin(new Payin(p));
    }

    self.pdf_path = ko.observable(data.pdf_path);

    self.gutschrift_path = ko.observable(data.gutschrift_path);
    self.partial_invoice_uuid = ko.observable(data.partial_invoice_uuid);
    self.inserted = ko.observable(data.inserted);

    self.invoice_type_short = function (invoice_type) {
      if (self.invoice_type() != undefined) {
        if (self.invoice_type() == "commission") {
          return "C";
        } else if (self.invoice_type() == "fee") {
          return "F";
        } else if (self.invoice_type() == "flatcommission") {
          return "CF";
        } else if (self.invoice_type() == 'fee-partial'){
            return 'FP';
        } else if (self.invoice_type() == 'commission-partial'){
            return 'CP';
        }
        else if (self.invoice_type() == "proartist") {
          return "PA";
        } else if (self.invoice_type() == "gift") {
          return "G";
        }
      } else {
        return "X";
      }
    };

    self.pretty_invoice_number = ko.computed(function () {
      return (
        self.invoice_type_short(self.invoice_type()) + self.invoice_number()
      );
    });

    self.cancel_extra_notes = function () {
      self.new_extra_notes(self.extra_notes());
      self.editing_extra_notes(false);
    };

    self.save_extra_notes = function () {
      self.editing_extra_notes(false);

      return $.ajax({
        url: self.rootvm.web_host + "/api/admin/invoice/extra-notes",
        type: "POST",
        data: ko.toJSON({
          invoice_uuid: self.invoice_uuid(),
          extra_notes: self.new_extra_notes(),
        }),
        processData: false,

        contentType: "application/json; charset=utf-8",

        success: function (data) {
          if (data.success) {
            self.extra_notes(data.extra_notes);
            self.new_extra_notes(data.extra_notes);
            self.editing_extra_notes(false);
            notyf.success("Saved!");
          } else {
            notyf.error(data.message);
            self.editing_extra_notes(true);
          }
        },
        error: function (jqXHR, errorStatus, thrownError) {
          var response = jQuery.parseJSON(jqXHR.responseText);
          notyf.error(response.message);
        },
        complete: function () {},
      });
    };

    self.update_send_reminder_emails = function () {
      return $.ajax({
        url: self.rootvm.web_host + "/api/admin/invoice/send-email-reminders",
        type: "POST",
        data: ko.toJSON({
          invoice_uuid: self.invoice_uuid(),
          send_email_reminders: self.new_send_email_reminders(),
        }),
        processData: false,

        contentType: "application/json; charset=utf-8",

        success: function (data) {
          if (data.success) {
            self.send_email_reminders(data.send_email_reminders);
            self.new_send_email_reminders(data.send_email_reminders);

            notyf.success("Saved!");
          } else {
            notyf.error(data.message);
            self.new_send_email_reminders(self.send_email_reminders());
          }
        },
        error: function (jqXHR, errorStatus, thrownError) {
          var response = jQuery.parseJSON(jqXHR.responseText);
          notyf.error(response.message);
        },
        complete: function () {},
      });
    };

    self.cancel_invoice = function () {
      //self.rootvm.is_busy(true);
      return $.ajax({
        url: self.rootvm.web_host + "/api/admin/invoice/cancel",
        type: "POST",
        data: ko.toJSON({
          invoice_uuid: self.invoice_uuid(),
        }),
        processData: false,

        contentType: "application/json; charset=utf-8",

        success: function (data) {
          if (data.success) {
            self.cancelled_date(new moment(data.cancelled).format("DD.MM.YY"));
            notyf.success("Cancelled!");
          } else {
            notyf.error(data.message);
          }
        },
        error: function (jqXHR, errorStatus, thrownError) {
          var response = jQuery.parseJSON(jqXHR.responseText);
          notyf.error(response.message);
        },
        complete: function () {
          //self.rootvm.is_busy(false);
        },
      });
    };

    self.un_cancel_invoice = function () {
      return $.ajax({
        url: self.rootvm.web_host + "/api/admin/invoice/un-cancel",
        type: "POST",
        data: ko.toJSON({
          invoice_uuid: self.invoice_uuid(),
        }),
        processData: false,

        contentType: "application/json; charset=utf-8",

        success: function (data) {
          if (data.success) {
            self.cancelled_date(undefined);
            notyf.success("un cancelled");
          } else {
            notyf.error(data.message);
          }
        },
        error: function (jqXHR, errorStatus, thrownError) {
          var response = jQuery.parseJSON(jqXHR.responseText);
          notyf.error(response.message);
        },
        complete: function () {},
      });
    };

    self.mark_invoice_refunded = function () {
      //self.rootvm.is_busy(true);
      return $.ajax({
        url: self.rootvm.web_host + "/api/admin/invoice/mark-refunded",
        type: "POST",
        data: ko.toJSON({
          invoice_uuid: self.invoice_uuid(),
        }),
        processData: false,

        contentType: "application/json; charset=utf-8",

        success: function (data) {
          if (data.success) {
            self.refunded_date(new moment(data.refunded).format("DD.MM.YY"));
            notyf.success("Marked refunded!");
          } else {
            notyf.error(data.message);
          }
        },
        error: function (jqXHR, errorStatus, thrownError) {
          var response = jQuery.parseJSON(jqXHR.responseText);
          notyf.error(response.message);
        },
        complete: function () {
          //self.rootvm.is_busy(false);
        },
      });
    };

    self.refund_iban = ko.observable();
    self.refund_bic = ko.observable();

    self.show_refund_error = ko.observable(false);

    self.is_refunding = ko.observable(false);
    // Live status shown in the auto-refund modal while we poll MangoPay
    self.refund_status_text = ko.observable("");
    self.refund_code = ko.observable(data.refund_code?.code);
    self.refund_code_amount = ko.observable();

    self.refund_percentage = ko.observable(20);
    self.artist_payout = ko.pureComputed(() =>{
        return parseInt(100 - self.refund_percentage());
    });

    self.mango_refund_over_master = () => {
      self.show_refund_error(false);

      if (!self.refund_iban()) {
        self.show_refund_error(true);
        return false;
      }

      self.is_refunding(true);

      console.log("NOW REFUNDING OVER MASTER!");
      // at the end mark it as refunded
      return $.ajax({
        url: self.rootvm.web_host + "/api/admin/refund-over-master",
        type: "POST",
        data: ko.toJSON({
          invoice_uuid: self.invoice_uuid(),
          iban: self.refund_iban(),
          bic: self.refund_bic(),
        }),
        processData: false,

        contentType: "application/json; charset=utf-8",

        success: function (data) {
          self.is_refunding(false);

          if (data.success) {
            self.mark_invoice_refunded();
            notyf.success("Pay out created!");
          } else {
            notyf.error(data.message);
          }
          const invRefundMaster = document.getElementById('invRefundMaster');
          Modal.getInstance(invRefundMaster)?.hide();
        },
        error: function (jqXHR, errorStatus, thrownError) {
          try {
            var response = jQuery.parseJSON(jqXHR.responseText);
            notyf.error(response.message);
          } catch (e) {
            console.error(e);
            notyf.error(response.message);
          }
          const invRefundMaster = document.getElementById('invRefundMaster');
          Modal.getInstance(invRefundMaster)?.hide();
          self.is_refunding(false);
        },
        complete: function () {
          //self.rootvm.is_busy(false);
        },
      });
    };

    // The refund resolves asynchronously (usually 20-30s), so once it's
    // created we keep the modal open and poll MangoPay until it lands on
    // SUCCEEDED or FAILED.
    var REFUND_POLL_INTERVAL_MS = 3000;
    var REFUND_POLL_MAX_ATTEMPTS = 20; // ~60s

    self.finish_auto_refund_success = () => {
      self.is_refunding(false);
      self.refund_status_text("Refund succeeded.");
      self.mark_invoice_refunded();
      notyf.success("Refund succeeded!");
      const invRefundAuto = document.getElementById('invRefundAuto');
      Modal.getInstance(invRefundAuto)?.hide();
    };

    self.poll_refund_status = (mangoRefundId, attempt) => {
      if (attempt > REFUND_POLL_MAX_ATTEMPTS) {
        self.is_refunding(false);
        self.refund_status_text(
          "Refund is still pending. It should resolve shortly - " +
          "reopen this to check again.");
        notyf.error("Refund still pending - check again shortly.");
        return;
      }

      $.ajax({
        url: self.rootvm.web_host + "/api/admin/refund-status",
        type: "POST",
        data: ko.toJSON({ mango_refund_id: mangoRefundId }),
        processData: false,
        contentType: "application/json; charset=utf-8",
        success: function (data) {
          if (!data.success) {
            self.is_refunding(false);
            self.refund_status_text(data.message);
            notyf.error(data.message);
            return;
          }

          if (data.resolved) {
            if (data.refund_status === "SUCCEEDED") {
              self.finish_auto_refund_success();
            } else {
              self.is_refunding(false);
              var msg = "Refund failed: " +
                (data.result_message || data.result_code || "unknown reason");
              self.refund_status_text(msg);
              notyf.error(msg);
            }
            return;
          }

          // Still CREATED/pending - keep waiting.
          self.refund_status_text(
            "Waiting for MangoPay to confirm the refund (" +
            (data.refund_status || "pending") + ")...");
          setTimeout(function () {
            self.poll_refund_status(mangoRefundId, attempt + 1);
          }, REFUND_POLL_INTERVAL_MS);
        },
        error: function (jqXHR, errorStatus, thrownError) {
          // A transient error polling shouldn't kill the whole flow - retry.
          console.error(thrownError);
          setTimeout(function () {
            self.poll_refund_status(mangoRefundId, attempt + 1);
          }, REFUND_POLL_INTERVAL_MS);
        },
      });
    };

    self.mango_auto_refund = () => {
      console.log("INITIATING REFUND");
      self.show_refund_error(false);
      self.is_refunding(true);
      self.refund_status_text("Submitting refund to MangoPay...");

      console.log("NOW REFUNDING OVER Auto!");
      // at the end mark it as refunded
      return $.ajax({
        url: self.rootvm.web_host + "/api/admin/refund-mango-auto",
        type: "POST",
        data: ko.toJSON({
          invoice_uuid: self.invoice_uuid(),
        }),
        processData: false,

        contentType: "application/json; charset=utf-8",

        success: function (data) {
          if (!data.success) {
            self.is_refunding(false);
            self.refund_status_text(data.message);
            notyf.error(data.message);
            return;
          }

          // Already resolved on creation (rare) - finish immediately.
          if (data.refund_status === "SUCCEEDED") {
            self.finish_auto_refund_success();
            return;
          }

          // Normal case: created and pending. Poll until it resolves.
          self.refund_status_text(
            "Refund created - waiting for MangoPay to confirm...");
          self.poll_refund_status(data.mango_refund_id, 1);
        },
        error: function (jqXHR, errorStatus, thrownError) {
          self.is_refunding(false);
          try {
            var response = jQuery.parseJSON(jqXHR.responseText);
            self.refund_status_text(response.message);
            notyf.error(response.message);
          } catch (e) {
            console.error(thrownError);
            notyf.error(errorStatus);
          }
          self.rootvm.is_busy(false);
        },
        complete: function () {
          //self.rootvm.is_busy(false);
        },
      });
    };


    self.create_refund_code = (amount) => {
      console.log("INITIATING REFUND");
      self.show_refund_error(false);
      self.is_refunding(true);

      console.log("Creating refund code!");
      // at the end mark it as refunded
      return $.ajax({
        url: self.rootvm.web_host + "/api/admin/create-refund-code-auto",
        type: "POST",
        data: ko.toJSON({
          invoice_uuid: self.invoice_uuid(),
          amount: self.refund_code_amount()
        }),
        processData: false,

        contentType: "application/json; charset=utf-8",

        success: function (data) {
          self.is_refunding(false);

          if (data.success) {
            //self.mark_invoice_refunded();
            self.refund_code(data.refund_code);
            notyf.success("Refund code created!");
            self.is_refunding(false);
          } else {
            notyf.error(data.message);
            self.is_refunding(false);
          }
        },
        error: function (jqXHR, errorStatus, thrownError) {
          try {
            var response = jQuery.parseJSON(jqXHR.responseText);
            notyf.error(response.message);
          } catch (e) {
            self.is_refunding(false);
            console.error(thrownError);
            notyf.error(errorStatus);
          }
          self.rootvm.is_busy(false);
        },
        complete: function () {
          //self.rootvm.is_busy(false);
        },
      });
    };

    self.create_partial_refund = () => {
      console.log("CREATING PARTIAL REFUND");
      self.show_refund_error(false);
      self.is_refunding(true);

      console.log("Creating refund code!");
      // at the end mark it as refunded
      return $.ajax({
        url: self.rootvm.web_host + "/api/admin/refund-partial-rewrite",
        type: "POST",
        data: ko.toJSON({
          invoice_uuid: self.invoice_uuid(),
          refund_percentage: self.refund_percentage()
        }),
        processData: false,

        contentType: "application/json; charset=utf-8",

        success: function (data) {
          self.is_refunding(false);

          if (data.success) {
            //self.mark_invoice_refunded();
            self.refund_code('F-' + data.new_fee_invoice_number);
            self.partial_invoice_uuid(data.partial_invoice_uuid);
            notyf.success("Partial's created!");
            self.is_refunding(false);
          } else {
            notyf.error(data.message);
            self.is_refunding(false);
          }
        },
        error: function (jqXHR, errorStatus, thrownError) {
          try {
            var response = jQuery.parseJSON(jqXHR.responseText);
            notyf.error(response.message);
          } catch (e) {
            self.is_refunding(false);
            console.error(thrownError);
            notyf.error(errorStatus);
          }
          self.rootvm.is_busy(false);
        },
        complete: function () {
          //self.rootvm.is_busy(false);
        },
      });
    };




    self.mark_as_paid_in = function (mark_related_c_invoice = false) {
      var answer = confirm(
        "are you sure you wanna pay in invoice " + self.pretty_invoice_number()
      );

      if (answer) {
        return $.ajax({
          url: scvm.web_host + "/api/admin/pay-in",
          type: "POST",
          data: ko.toJSON({
            invoice_uuid: self.invoice_uuid(),
            mark_related_c_invoice: mark_related_c_invoice,
          }),
          processData: false,

          contentType: "application/json; charset=utf-8",

          success: function (data) {
            if (data.success) {
              self.paid_date(new moment(data.paid_date).format("DD.MM.YY"));
              notyf.success("Paid!");
            } else {
              notyf.error(data.message);
            }
          },
          error: function (data) {
            notyf.error(data);
          },
          complete: function () {},
        });
      }
    };
  }
}
export class BankAccount {
  constructor(data) {
    var self = this;
    self.type = "BankAccount";
    self.aba = ko.observable(data.aba);
    self.account_number = ko.observable(data.account_number);
    self.address = ko.observable(data.address);
    (self.address_line_two = ko.observable(data.address_line_two)),
      (self.bank_account_type = ko.observable(data.bank_account_type));
    self.bank_account_uuid = ko.observable(data.bank_account_uuid);
    self.bank_name = ko.observable(data.bank_name);
    self.bic = ko.observable(data.bic);
    self.city = ko.observable(data.city);
    self.country = ko.observable(data.country);
    self.created_by = ko.observable(data.created_by);
    self.deposit_account_type = ko.observable(data.deposit_account_type);
    self.full_pretty_address = ko.observable(
      data.full_pretty_address || data.address
    );
    self.iban = ko.observable(data.iban);
    self.inserted = ko.observable(data.inserted);
    self.institution_number = ko.observable(data.institution_number);
    self.mangopayid = ko.observable(data.mangopayid);
    self.owner_name = ko.observable(data.owner_name);
    self.postal_code = ko.observable(data.postal_code);
    self.region = ko.observable(data.region);
    self.sort_code = ko.observable(data.sort_code);
    self.street = ko.observable(data.street);
    self.street_number = ko.observable(data.street_number);
    self.updated = ko.observable(data.updated);

    self.google_maps_mapping = {
      street_number: self.street_number,
      route: self.street,
      locality: self.city,
      postal_town: self.city,
      sublocality_level_1: self.city,
      administrative_area_level_1: self.region,
      country: self.country,
      postal_code: self.postal_code,
      postal_code_prefix: self.postal_code,
    };

    self.google_maps_components = {
      street_number: "short_name",
      route: "long_name",
      locality: "long_name",
      postal_town: "long_name",
      sublocality_level_1: "long_name",
      administrative_area_level_1: "long_name",
      country: "short_name",
      postal_code: "short_name",
      postal_code_prefix: "short_name",
    };

    self.reset_location = function () {
      self.address(undefined);
      self.address_line_two(undefined);
      self.region(undefined);
      self.street(undefined);
      self.street_number(undefined);
      self.city(undefined);
      self.postal_code(undefined);
      self.country(undefined);
      self.full_pretty_address(undefined);
    };
  }
}

export class BillingDetails {
  constructor(data) {
    var self = this;
    self.type = "BillingDetails";

    self.billing_details_uuid = ko.observable(data.billing_details_uuid);
    self.first_name = ko.observable(data.first_name);
    self.last_name = ko.observable(data.last_name);
    self.full_pretty_address = ko.observable(data.full_pretty_address);

    self.company = ko.observable(data.company);
    self.billing_address = ko.observable(data.billing_address);
    self.billing_address_line_two = ko.observable(
      data.billing_address_line_two
    );
    self.billing_details_uuid = ko.observable(data.billing_details_uuid);
    self.billing_region = ko.observable(data.billing_region);
    self.billing_street = ko.observable(data.billing_street);
    self.billing_street_number = ko.observable(data.billing_street_number);
    self.birthday = ko.observable(data.birthday);
    self.city = ko.observable(data.city);
    self.company = ko.observable(data.company);
    self.company_number = ko.observable(data.company_number);
    self.country = ko.observable(data.country);
    self.first_name = ko.observable(data.first_name);
    self.full_pretty_address = ko.observable(data.full_pretty_address);
    self.inserted = ko.observable(data.inserted);
    self.last_name = ko.observable(data.last_name);
    self.legal_form = ko.observable(data.legal_form);

    if (self.legal_form() == undefined) {
      self.legal_form("individual");
    }

    self.mango_pay_user = ko.observable(data.mango_pay_user);
    self.mangopayid = ko.observable(data.mangopayid);
    self.card_id = ko.observable(data.card_id);

    self.bank_account_uuid = ko.observable(data.bank_account_uuid);
    self.bank_account = ko.observable(new BankAccount(data.bank_account || {}));

    self.nationality = ko.observable();
    if (data.nationality) {
      self.nationality(data.nationality.toLowerCase());
    }

    self.person_uuid = ko.observable(data.person_uuid);
    self.postal_code = ko.observable(data.postal_code);
    self.tax_id = ko.observable(data.tax_id);
    self.tax_rate = ko.observable(data.tax_rate);
    self.updated = ko.observable(data.updated);
    self.walletmangopayid = ko.observable(data.walletmangopayid);

    self.tax_rate_percent = ko.pureComputed(function () {
      if (self.tax_rate()) {
        var x = ko.utils.arrayFirst(TAXRATE_TYPES, function (item) {
          return item.value == self.tax_rate();
        });
        if (x) {
          return x.percentage;
        }
      }
    });

    self.pretty_formatted_birthday = ko.computed(function () {
      if (self.birthday()) {
        return new moment(self.birthday()).format("DD.MM.YYYY");
      }
    });

    self.full_name = ko.computed(function () {
      return self.first_name() + " " + self.last_name();
    });

    self.pretty_deets = ko.computed(function () {
      var deets = "";

      if (self.company()) {
        deets += self.company() + "<br />";
      }
      deets += self.first_name() + " " + self.last_name() + "<br />";
      deets += self.full_pretty_address();

      return deets;
    });

    self.update_self = function (data) {
      self.first_name(data.first_name);
      self.last_name(data.last_name);
      self.full_pretty_address(data.full_pretty_address);

      self.company(data.company);
      self.billing_address(data.billing_address);
      self.billing_address_line_two(data.billing_address_line_two);
      self.billing_details_uuid(data.billing_details_uuid);
      self.billing_region(data.billing_region);
      self.billing_street(data.billing_street);
      self.billing_street_number(data.billing_street_number);
      self.birthday(data.birthday);
      self.city(data.city);
      self.company(data.company);
      self.company_number(data.company_number);
      self.country(data.country);
      self.full_pretty_address(data.full_pretty_address);
      self.inserted(data.inserted);
      self.legal_form(data.legal_form);
      self.mangopayid(data.mangopayid);

      if (data.nationality) {
        self.nationality(data.nationality.toLowerCase());
      }
    };

    // Map our values to google maps values
    self.google_maps_mapping = {
      street_number: self.billing_street_number,
      route: self.billing_street,
      locality: self.city,
      postal_town: self.city,
      sublocality_level_1: self.city,
      administrative_area_level_1: self.billing_region,
      country: self.country,
      postal_code: self.postal_code,
      postal_code_prefix: self.postal_code,
    };

    self.google_maps_components = {
      street_number: "short_name",
      route: "long_name",
      locality: "long_name",
      postal_town: "long_name",
      sublocality_level_1: "long_name",
      administrative_area_level_1: "long_name",
      country: "short_name",
      postal_code: "short_name",
      postal_code_prefix: "short_name",
    };

    self.reset_location = function () {
      self.billing_address(undefined);
      self.billing_address_line_two(undefined);
      self.billing_details_uuid(undefined);
      self.billing_region(undefined);
      self.billing_street(undefined);
      self.billing_street_number(undefined);
      self.city(undefined);
      self.postal_code(undefined);
      self.country(undefined);
      self.full_pretty_address(undefined);
    };
  }
}
export class KYCDocument {
  constructor(data) {
    var self = this;
    self.type = "KYCDocument";

    console.log(data);

    self.kyc_doc_uuid = ko.observable(data.kyc_doc_uuid);
    self.kyc_document_type = ko.observable(data.kyc_document_type);
    self.billing_details_uuid = ko.observable(data.billing_details_uuid);

    self.original_filename = ko.observable(data.original_filename);

    self.current_status = ko.observable(data.current_status);
    self.refused_reason = ko.observable(data.refused_reason);

    self.status_css = ko.pureComputed(function () {
      if (self.current_status() == "validation_asked") {
        return "yellow";
      } else if (
        self.current_status() == "validated" ||
        self.current_status() == "succeeded"
      ) {
        return "green";
      } else if (self.current_status() == "refused") {
        return "red";
      } else {
        return "";
      }
    });
  }
}
export class Country {
  constructor(data) {
    var self = this;
    self.type = "Country";

    self.country_abr = data.country_abr;
    self.country = data.country;
  }
}

export class Payout {
  constructor(data) {
    var self = this;
    self.type = "Payout";
    self.rootvm = data.rootvm;

    if (data == undefined) {
      data = {};
    }

    self.payout_uuid = ko.observable(data.payout_uuid);
    self.payout_status = ko.observable(data.payout_status);
    self.mango_payout_id = ko.observable(data.mango_payout_id);
    self.inserted = ko.observable(new moment(data.inserted));

    self.lookup_status = function () {
      return $.ajax({
        url: self.rootvm.web_host + "/api/admin/payout-status",
        type: "GET",
        data: {
          payout_uuid: self.payout_uuid(),
        },

        contentType: "application/json; charset=utf-8",

        success: function (data) {
          if (data.payout.payout_status != self.payout_status()) {
            self.payout_status(data.payout.payout_status);
          }
        },
        error: function (data) {
          notyf.error(data.message);
        },
        complete: function () {},
      });
    };
  }
}

export class Payin {
  constructor(data) {
    var self = this;
    self.type = "Payin";
    self.rootvm = data.rootvm;

    if (data == undefined) {
      data = {};
    }

    self.payin_uuid = ko.observable(data.payin_uuid);
    self.payin_status = ko.observable(data.payin_status);

    self.payin_tag = ko.observable(data.payin_tag);

    self.inserted = ko.observable(new moment(data.inserted));

    self.expires = ko.pureComputed(function () {
      if (self.inserted() > new moment("2022-06-13")) {
        return self.inserted().clone().add(6, "month");
      } else {
        return self.inserted().clone().add(2, "month");
      }
    });

    self.payin_status_inserted = ko.observable();
    if (data.payin_status_inserted) {
      self.payin_status_inserted(new moment(data.payin_status_inserted));
    }
    self.mango_payin_id = ko.observable(data.mango_payin_id);

    self.payin_tag_bg_color = ko.pureComputed(function () {
      if (self.payin_tag()) {
        if (self.payin_tag() == "Kunden nicht erreicht") {
          return "bg-danger";
        } else if (self.payin_tag() == "Austausch mit Kund*in") {
          return "bg-warning";
        } else if (self.payin_tag() == "Warten auf Zahlungsbeleg") {
          return "bg-info";
        } else {
          return "bg-primary";
        }
      }
    });

    self.lookup_status = function () {
      return $.ajax({
        url: self.rootvm.web_host + "/api/admin/payin-status",
        type: "GET",
        data: {
          payin_uuid: self.payin_uuid(),
        },

        contentType: "application/json; charset=utf-8",

        success: function (data) {
          if (data.payin.payin_status != self.payin_status()) {
            self.payin_status(data.payin.payin_status);
          }
        },
        error: function (data) {
          notyf.error(data.message);
        },
        complete: function () {},
      });
    };

    self.add_payin_tag = function (payin_tag) {
      return $.ajax({
        url: self.rootvm.web_host + "/api/admin/payin/payin-tag",
        type: "POST",
        data: ko.toJSON({
          payin_uuid: self.payin_uuid(),
          payin_tag: payin_tag,
        }),

        contentType: "application/json; charset=utf-8",

        success: function (data) {
          self.payin_tag(payin_tag);
        },
        error: function (data) {
          notyf.error(data.message);
        },
        complete: function () {},
      });
    };

    self.remove_payin_tag = function () {
      return $.ajax({
        url: self.rootvm.web_host + "/api/admin/payin/payin-tag",
        type: "DELETE",
        data: ko.toJSON({
          payin_uuid: self.payin_uuid(),
        }),

        contentType: "application/json; charset=utf-8",

        success: function (data) {
          self.payin_tag(undefined);
        },
        error: function (data) {
          notyf.error(data.message);
        },
        complete: function () {},
      });
    };
  }
}
